import { createSelector } from "reselect";

export const getClientes = (state) => state.clientes;

export const getListaClientes = createSelector(
  getClientes,
  (state) => state.lista
);
export const isCarregandoClientes = createSelector(
  getListaClientes,
  (state) => state.loading
);
export const getConteudoClientes = createSelector(
  getListaClientes,
  (state) => state.conteudo
);

export const isCarregandoResumo = createSelector(
  getClientes,
  (state) => state.resumo.loading
);
export const getResumo = createSelector(
  getClientes,
  (state) => state.resumo.data
);
export const getListaPaging = createSelector(getListaClientes, (state) => ({
  total: state.totalElementos,
  tamanho: state.tamanho,
}));

export const isCarregandoDetalhesCliente = createSelector(
  getClientes,
  (state) => state.detalhes.loading
);
export const getDetalhesCliente = createSelector(
  getClientes,
  (state) => state.detalhes.data
);
export const isIniciandoRelacionada = createSelector(
  getClientes,
  (state) => state.detalhes.initing
);
export const getDominioParceiros = createSelector(
  getClientes,
  (state) => state.dominios.parceiros
);
export const getDominioProdutos = createSelector(
  getClientes,
  (state) => state.dominios.produtos
);
export const getDominioInstituicoesFinanceiras = createSelector(
  getClientes,
  (state) => state.dominios.instituicoesFinanceiras
);
export const getDocumentos = createSelector(
  getClientes,
  (state) => state?.detalhes.data.documentos
);
export const isBaixandoArquivos = createSelector(
  getClientes,
  (state) => state.detalhes.downloading
);
export const isSubindoArquivos = createSelector(
  getClientes,
  (state) => state.detalhes.uploading
);
export const getDominiosCliente = createSelector(
  getClientes,
  (state) => state.detalhes.dominios
);
export const isCarregandoPreenchimentoCliente = createSelector(
  getClientes,
  (state) => state.preenchimento.loading
);
export const getPreenchimentoCliente = createSelector(
  getClientes,
  (state) => state.preenchimento.data
);
export const isGravandoPreenchimentoCliente = createSelector(
  getClientes,
  (state) => state.preenchimento.submitting
);
export const isEnviandoPreenchimentoCliente = createSelector(
  getClientes,
  (state) => state.preenchimento.sending
);